import { fetchWithAuth } from "./cartService";

const BASE_URL = process.env.REACT_APP_API_URL ; 

// =======================
// VALIDATE REFERRAL CODE (check before applying)
// =======================
export const validateReferralCodeAPI = async (code) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/referral/validate`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ referralCode: code }),
    });
    return await res.json();
  } catch (error) {
    console.error("Validate referral error:", error);
    return null;
  }
};

// =======================
// APPLY REFERRAL CODE
// =======================
export const applyReferralCodeAPI = async (code) => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/referral/apply`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ referralCode: code }),
    });
    return await res.json();
  } catch (error) {
    console.error("Apply referral error:", error);
    return null;
  }
};

// =======================
// APPLY LOYALTY DISCOUNT
// =======================
export const applyLoyaltyDiscountAPI = async () => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/referral/apply-loyalty`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
    });
    return await res.json();
  } catch (error) {
    console.error("Apply loyalty error:", error);
    return null;
  }
};

// =======================
// REMOVE LOYALTY DISCOUNT
// =======================
export const removeLoyaltyDiscountAPI = async () => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/referral/remove-loyalty`, {
      method: "DELETE",
    });
    return await res.json();
  } catch (error) {
    console.error("Remove loyalty error:", error);
    return null;
  }
};

// =======================
// GET MY REFERRAL INFO
// =======================
export const getMyReferralInfoAPI = async () => {
  try {
    const res = await fetchWithAuth(`${BASE_URL}/referral/my-info`);
    return await res.json();
  } catch (error) {
    console.error("Get referral info error:", error);
    return null;
  }
};